import { LoadableBackground } from '@confluence/loadable';

export { TriggerFrom } from '../src/PremiumTrialOnboardingModal.tsx';

export const PremiumTrialOnboardingModal = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumOnboardingModal" */ '../src/PremiumTrialOnboardingModal.tsx'
			)
		).PremiumTrialOnboardingModal,
});
